module.exports = __webpack_public_path__ + "img/digitalIdentity9.71f7e687.png";